// game-manager.js
export class GameManager {
    constructor(iframe) {
        this.iframe = iframe;
        this.isActive = false;
        this.visibilityHandler = null;

        if (iframe) {
            this.setupIframe();
            this.setupVisibility();
        }
    }

    setupIframe() {
        // Set proper attributes for game functionality
        this.iframe.sandbox = 'allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-pointer-lock allow-orientation-lock';
        this.iframe.referrerPolicy = 'no-referrer-when-downgrade';
        this.iframe.allow = 'autoplay; fullscreen; gamepad; microphone; camera; display-capture';

        // Add load event - don't clone iframe as it breaks Vue refs
        this.iframe.addEventListener('load', () => {
            this.isActive = true;
            console.log('Game loaded and ready');
        });
    }

    setupVisibility() {
        // Handle page visibility changes
        this.visibilityHandler = () => {
            if (document.hidden) {
                this.pauseGame();
            } else {
                this.resumeGame();
            }
        };

        document.addEventListener('visibilitychange', this.visibilityHandler);
    }

    pauseGame() {
        if (this.iframe && this.isActive) {
            try {
                this.iframe.contentWindow.postMessage({
                    action: 'pause'
                }, '*');
                console.log('Game Paused');
            } catch (e) {
                // Game doesn't support messaging
            }
        }
    }

    resumeGame() {
        if (this.iframe && this.isActive) {
            try {
                this.iframe.contentWindow.postMessage({
                    action: 'resume'
                }, '*');
                console.log('Game Resumed');
            } catch (e) {
                // Game doesn't support messaging
            }
        }
    }

    toggleFullscreen() {
        if (!this.iframe) return;

        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            this.iframe.requestFullscreen().catch(err => {
                console.log(`Error attempting to enable fullscreen: ${err.message}`);
            });
        }
    }

    destroy() {
        // Remove event listeners
        if (this.visibilityHandler) {
            document.removeEventListener('visibilitychange', this.visibilityHandler);
        }

        // Exit fullscreen if active
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }

        // Clear references
        this.iframe = null;
        this.isActive = false;
        this.visibilityHandler = null;
    }
}